import React, {memo} from 'react';
import Image from 'next/image';
import Container from '@/components/atoms/Container';
import ArrowButton from '@/components/atoms/ArrowButton';
import styles from './HomeImageCTA.module.scss';

// MUI-free copy of Ui-components/home/HomeImageCTA.

interface HomeImageCTAProps {
    /** Supports inline markup (e.g. `<strong>`) — content is authored in the data layer, not user input. */
    heading: string;
    subheading: string;
    buttonText: string;
    imageSrc: string;
    imageAlt: string;
    /** Click handler that opens the contact form, or a URL when `meetingLink` is set. */
    openForm?: any;
    meetingLink?: boolean;
    /** Set for artwork that is light and full-bleed: the card drops its navy ground and
     *  the copy switches to dark text so it stays legible on the picture. */
    light?: boolean;
}

const HomeImageCTA = ({heading, subheading, buttonText, imageSrc, imageAlt, openForm, meetingLink, light = false}: HomeImageCTAProps) => {
    return (
        <Container>
            <div className={`${styles.card} ${light ? styles.light : styles.dark}`}>
                <div className={styles.imageWrap}>
                    <Image src={imageSrc} alt={imageAlt} fill quality={90} sizes="100vw" />
                </div>
                <div className={styles.content}>
                    {/* Promotional copy, not a document heading, so it stays out of the page outline. */}
                    <p className={`font-headers ${styles.heading}`} dangerouslySetInnerHTML={{__html: heading}} />
                    <p className={`font-regular-text ${styles.subheading}`} dangerouslySetInnerHTML={{__html: subheading}} />
                    {meetingLink ? (
                        <ArrowButton variant="orange" href={openForm} target="_blank" className={`${styles.button} ${styles.linkButton}`}>
                            {buttonText}
                        </ArrowButton>
                    ) : (
                        <ArrowButton variant="orange" className={styles.button} onClick={openForm}>
                            {buttonText}
                        </ArrowButton>
                    )}
                </div>
            </div>
        </Container>
    );
};

export default memo(HomeImageCTA);
